import React, { Component } from 'react';
import { listLanguage } from '../../../../configs/LanguageConfig';
import { setLocale } from 'react-redux-i18n';
import { connect } from 'react-redux';
import iconUk from '../../../../assets/images/flag/uk.svg';
import iconVi from '../../../../assets/images/flag/vi.png';
import { callApiSystemSetting, REDUCER_NAME } from '../../sidebar/reducer';
import { saveLanguage, changeUILanguage } from './../../../helpers/Language';
import { changeLanguage } from './../../../app/reducer';
import {
  fetchOrganization,
  fetchIndustry,
  fetchCompanyGroup,
  fetchDerivative,
  fetchAllCoveredWarrant,
} from './../../../app/commonReducer';
import { Translate } from 'react-redux-i18n';
import { isNotLogin } from '../../../helpers/Common';

class Language extends Component {
  constructor(props) {
    super(props);
    this.state = { isShowPopup: false };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      language,
      fetchOrganization,
      fetchIndustry,
      fetchCompanyGroup,
      fetchDerivative,
      fetchAllCoveredWarrant,
    } = this.props;

    if (prevProps.language !== language) {
      this.changeUILanguage(language);
      saveLanguage(language);
      fetchOrganization();
      fetchIndustry();
      fetchCompanyGroup();
      fetchDerivative();
      fetchAllCoveredWarrant();
    }
  }

  changeUILanguage = language => {
    const { setLocale } = this.props;
    setLocale(language);
    changeUILanguage(language);
  };

  handleClick = language => () => {
    const {
      changeLanguage,
      dataSystem,
      callApiSystemSetting,
      user,
    } = this.props;

    if (!isNotLogin(user)) {
      callApiSystemSetting({
        ...dataSystem,
        language,
      });
    }

    changeLanguage(language);
    this.setState({ isShowPopup: false });
  };

  toggleShowPopup = isShowPopup => () => {
    this.setState({ isShowPopup });
  };

  renderIcon = () => {
    const { language } = this.props;

    return (
      <span>
        <img alt="" src={language === 'en' ? iconUk : iconVi} />
      </span>
    );
  };

  render() {
    const { isShowPopup } = this.state;
    return (
      <div className="fiidropdown right change-language ml-6">
        <a
          id="language-tutorial"
          href="#"
          className="bor-ts-color-2"
          onMouseEnter={this.toggleShowPopup(true)}
        >
          {this.renderIcon()}
        </a>
        <ul className={`dropdown-nav caret ${isShowPopup ? '' : 'hidden'}`}>
          {Object.keys(listLanguage).map((lang, index) => {
            return (
              <li key={index}>
                <a href="#" onClick={this.handleClick(lang)}>
                  <Translate value={`systemSetting.radioButtonTitle.${lang}`} />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.language,
    dataSystem: state[REDUCER_NAME].settingSystem.dataSystem,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  setLocale,
  changeLanguage,
  fetchOrganization,
  fetchIndustry,
  fetchCompanyGroup,
  fetchDerivative,
  callApiSystemSetting,
  fetchAllCoveredWarrant,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Language);
